(function() {
    window.c24.lp.ipss = {
        bIsMobile: window.c24LpIsMobile,
        iTimeout: 6000,
        aApiDataResult: null,
        aNonContractsGrouped: [], // contains all data except type: 'contract'
        aContractsGrouped: [], // should contain only contracts with type: 'contract'
        aContractTypes: ['contract', 'foreignContract'], // Types that should be considered to be a contract
        aNoneContractTypes: ['incompleteContract', 'offer'], // Types that should be considered to be a non contract
        iconMap: {},
        defaultPriceUnit: 'euro',
        priceUnitMap: {
            'euro': '\u20ac',
            'percent': '\u0025',
        },
        periodMap: {
            'monthly': 'monatlich',
            'month': 'monatlich',
            'quarterly': 'vierteljährlich',
            'quarter': 'vierteljährlich',
            'semester': 'halbjährlich',
            'yearly': 'jährlich',
            'year': 'jährlich',
            'once': 'einmalig',
        },
        personMap: {
            'single': 'Single',
            'couple': 'Paar ohne Kind',
            'single-family': 'Single mit Kind',
            'singlewithchild': 'Single mit Kind(ern)',
            'familywithchild': 'Familie mit Kind(ern)',
            'family': 'Familie',
            'child': 'Kind',
            'children': 'Kinder',
        },
        employmentStatusMap: {
            'employee': 'Arbeitnehmer',
            'student': 'Student',
            'trainee': 'Auszubildender',
            'schooledstudent': '(Berufs-)Schüler',
            'selfemployed': 'Selbstständig',
            'selfemployedwithfoundergrant': 'Selbstständig',
            'publicservice': 'Öffentlicher Dienst',
            'civilservant': 'Beamter',
            'unemploymentbenefitone': 'ALG I Empfänger',
            'unemploymentbenefittwo': 'ALG II Empfänger',
            'socialbenefit': 'Sozialhilfe-Empfänger',
            'retiree': 'Rentner',
            'pensioner': 'Pensionär',
            'unemployed': 'Ohne berufliche Tätigkeit',
            'other': 'Sonstige Berufsgruppe',
        },
        timeWordingMap: {
            'offer': 'erstellt',
            'incompleteContract': 'begonnen',
            'contract': 'abgeschlossen',
            'foreignContract': '',
        },
        bClonedElementNonContracts: false,
        bClonedElementContracts: false,
        oElementTemplateLastSearches: null,
        oElementTemplateArrangement: null,
        oElementTemplateContract: null,
        oElementTemplateForeignContract: null,
        bCommaAfterPersonType: true,
        bCommaAfterPersonJob: true,
        bContractsExists: true,
        bNonContractsExists: true,
        bPriceInCents: false, // Ist Preis in Cent
        bDecimalSeparator: true, // Preis mit dezimalstellen
        bThousandsSeparator: false, // preis mit tausender Trenner
        sLastUrl: '',
        bReloadIpssEventRegistered: false,
        sDeleteMethod: 'POST',
        sRenderType: 'lastSearches',
        filterPersons: false, // Personentext Ersetzung UN
        overrideData: false, // Testdaten zum Entwickeln
        bShowEverything: false, // show lastSearches, incompleteContracts & offers at same time
        bShowContracts: false,
        renderingDone: $.Deferred(),
        iSortItemsByTimestamp: 0, // 1: newest on top. 0: no sort. -1: oldest on top.,
        fadeTeaser: true,
        fadeTeaserDelay: 500,
        ipssTest: window.location.href.toLowerCase().indexOf('ipsstest') >= 0 && (!window.c24LpIsProduction || window.c24LpIpssDebug),
        counts: {
            contracts: 0,
            offers: 0,
            incompleteContracts: 0,
            offersGroup: 0, // should always be the sum of 'offers' and 'incompleteContracts'.
            contractsGroup: 0, // should equals the contracts count
            lastSearches: 0,
        },
        product: '', // The directory of the product. Will be used for URL-Stuff.
        prefix: '',

        init: function(domContext, sUrl, iTimeout, product = '') {
            this.domContext = domContext;

            if (!$('.js24VsIpss', this.domContext).length) {
                return;
            }

            if ($('.js24VsIpss', this.domContext).data('showeverything') === 1) {
                this.bShowEverything = true;
            }

            if ($('.tabNavi', this.domContext).length) {
                this.bShowContracts = true;
            }

            if (product !== '') {
                this.product = product;
            }

            this.prefix = domContext.data('prefix') || this.product;

            this.iTimeout = iTimeout || 6000;

            this.sLastUrl = sUrl;

            this.activateTracking();

            if ($('.js24VsIpss', this.domContext).data('ipssactive') === 1 || this.isLoadedFromCache() || this.ipssTest) {
                this.getAPiData(sUrl);
            }

            this.registerReloadIpssEvent();
        },

        setLoadingState: function(state) {
            let ticker;
            let tick = 0;
            const maxTicks = 50;
            const $ac = this.domContext;
            const counts = this.counts;
            let totalCount = 0;

            if (state) {
                $ac.addClass('c24-is-loading');
                if (!$('.c24-loader', this.domContext).length) {
                    $('<span class="c24-loader"></span>', this.domContext)
                        .appendTo($ac);
                }
            } else {
                ticker = setInterval(function() { // wait until all placeholders are replaced since they are not included in the promise chain
                    tick++;
                    if (!$ac.find('.no-data').length || tick >= maxTicks) {
                        $ac.removeClass('c24-is-loading');
                        $('.c24-loader', this.domContext).stop().fadeOut(500);
                        for (const count in counts) {
                            totalCount += counts[count];
                        }
                        if (totalCount > 0) {
                            $('.box24VsIpssWrapper', $ac).stop().hide().removeClass('c24Hidden').fadeIn(500);
                        }
                        clearInterval(ticker);
                    }
                }, 200);
            }
        },

        // Hole Api Daten
        getAPiData: function(sUrl) {
            const self = this;

            if (this.domContext.data('has-last-search')) {
                this.setLoadingState(true);
            }

            if (this.ipssTest) {
                this.getApiTestData();
                return;
            }

            $.ajax({
                dataType: 'json',
                url: sUrl,
                xhrFields: {
                    withCredentials: true,
                },
                contentType: 'application/json; charset=UTF-8',
                async: true,
                timeout: this.iTimeout,
                cache: false,

            }).done(function(data) {

                data = self.getApiDataAlter(data);
                self.aApiDataResult = JSON.parse(JSON.stringify(data));

                self.startIpssLogic();

                if (Object.keys(self.aApiDataResult).length <= 1) {
                    self.setLoadingState(false);
                }

                $.when(self.renderingDone).done(function() {
                    self.setLoadingState(false);
                });

            }).fail(function() {
                self.showDefaultTeaser(self);
                self.setLoadingState(false);
            });
        },

        getApiDataAlter: function(data) {
            return data;
        },

        getApiTestData: function() {
            const self = this;

            console.log(
                '%cIPSS Test läuft! (' + this.product + ')',
                'font-size: 38px; font-weight: 700; color: #ff0000; text-shadow: 1px 1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, -1px -1px 0px #000;',
            );

            $.ajax({
                dataType: 'json',
                url: '/' + this.product + '/js/c24IpssTestData.json',
                async: true,
            }).done(function (data) {
                data = self.getApiTestDataAlter(data);
                self.overrideData = data;
                console.log(self.overrideData);
            }).fail(function () {
                console.log('Could not load test data from: "' + self.product + '/js/c24IpssTestData.json". Using');
            }).always(function () {
            // If we have no test data, we can not test.
                if (self.overrideData === false) {
                    console.log('No overrideData found');
                    return;
                }

                console.log('____________________________________________________________________________');
                self.overrideData = self.getApiDataAlter(self.overrideData);
                self.aApiDataResult = JSON.parse(JSON.stringify(self.overrideData));

                self.startIpssLogic();

                $.when(self.renderingDone).done(function () {
                    self.setLoadingState(false);
                });
            });
        },

        getApiTestDataAlter: function(data) {
            return data;
        },

        startIpssLogic: function() {

            const self = this;

            self.groupDataResult();
            self.sortDataResult();

            $('.box24VsIpss', self.domContext).trigger('c24IpssActive'); // tracking class

            // processing lastSearches, incompletedContracts and offers
            self.handleNonContracts();

            // processing all contracts data
            self.handleContracts();

            // once the items have been handled, do the counters.
            self.renderCounters();

            if (((self.bContractsExists || self.bNonContractsExists) && self.bShowContracts) || (self.bNonContractsExists && !self.bShowContracts)) {
                self.showIpssTeaser();
            }
        },

        groupDataResult: function() {
            const self = this;

            self.countItemTypes();

            // if extended ipss is activated in ac module
            if (self.bShowContracts) {
                self.registerTabSwitchEvent();
            }

            if (self.bShowEverything) {
                self.sRenderType = 'ipss';

                self.aNonContractsGrouped = self.aApiDataResult;
            } else {
                if (self.aApiDataResult.contracts) { // check if contracts exists in API
                    self.sRenderType = 'lastSearches';

                    self.aApiDataResult.contracts.forEach(function (data) {
                        if (self.aNoneContractTypes.indexOf(data.type) > -1) {
                            self.sRenderType = data.type;
                            return;
                        }
                    });

                }

                if (self.sRenderType === 'lastSearches') {
                    self.aNonContractsGrouped = self.aApiDataResult.lastSearches;
                } else {
                    self.aNonContractsGrouped = self.aApiDataResult.contracts;
                }
            }

            if (self.bShowContracts) {
                self.aContractsGrouped = [];
                if (self.aApiDataResult.contracts) {
                    self.aContractsGrouped = self.aApiDataResult.contracts.filter(function(item) {
                        return self.aContractTypes.indexOf(item.type) > -1;
                    });
                }

                let nonContracts = [];
                if (self.aApiDataResult.contracts) {
                    nonContracts = self.aApiDataResult.contracts.filter(function(item) {
                        return self.aNoneContractTypes.indexOf(item.type) > -1;
                    });
                }

                self.aNonContractsGrouped.contracts = nonContracts;
            }
        },

        countItemTypes: function() {
        // Counting
            const self = this;
            this.counts.lastSearches = (this.aApiDataResult.lastSearches ? this.aApiDataResult.lastSearches.length : 0);
            if (this.aApiDataResult.contracts) {
                this.aApiDataResult.contracts.forEach(function (contract) {

                    switch (contract.type) {
                        case 'offer':
                            self.counts.offers++;
                            break;
                        case 'incompleteContract':
                            self.counts.incompleteContracts++;
                            break;
                        case 'contract':
                        case 'foreignContract':
                        default:
                            self.counts.contracts++;
                    }

                    if (self.aNoneContractTypes.indexOf(contract.type) > -1) {
                        self.counts.offersGroup++;
                    } else if (self.aContractTypes.indexOf(contract.type) > -1) {
                        self.counts.contractsGroup++;
                    }

                });
            }
        },

        sortDataResult: function() {

            const self = this;

            // Sort the foreign contracts to the bottom
            if (self.bShowContracts && self.aContractsGrouped.length > 1) {
                self.aContractsGrouped.sort(function(a, b) {
                    if (a.type !== b.type) {
                        if (a.type === 'foreignContract') {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                });
            }

            // If we're not asked to sort, we won't sort.
            if (self.iSortItemsByTimestamp === 0) {
                return;
            }

            if (!self.bShowEverything) {
            // if showEverything isn't enabled, aNonContractsGrouped has a different structure, which we'll not
            // take care of... for now.
                return;
            }

            // Sort the nonContracts
            self.aNonContractsGrouped.contracts.sort(function(a, b) {

                if (a.time < b.time) {
                    return self.iSortItemsByTimestamp;
                }
                if (a.time > b.time) {
                    return self.iSortItemsByTimestamp * -1;
                }

                return 0;
            });

            // Sort the lastSearches
            self.aNonContractsGrouped.lastSearches.sort(function(a, b) {

                if (a.time < b.time) {
                    return self.iSortItemsByTimestamp;
                }
                if (a.time > b.time) {
                    return self.iSortItemsByTimestamp * -1;
                }

                return 0;
            });

            // Sort the contracts
            if (self.bShowContracts && self.aContractsGrouped.length > 1) {
                self.aContractsGrouped.sort(function(a, b) {

                    if (a.time < b.time) {
                        return self.iSortItemsByTimestamp;
                    }
                    if (a.time > b.time) {
                        return self.iSortItemsByTimestamp * -1;
                    }

                    return 0;
                });
            }
        },

        handleNonContracts: function() {
            const self = this;

            if (!self.isValidApiResponse(self.aNonContractsGrouped)) {
                self.showDefaultTeaser(self);

                self.noExistingNonContracts();

                if (!self.bShowContracts) {
                    return;
                }
            } else {
                self.renderList();
            }

            self.renderHeadlineNonContracts();
        },

        handleContracts: function() {
            const self = this;

            // handle contracts
            if (self.bShowContracts) {
                if (!self.isValidContractsGrouped(self.aContractsGrouped)) {
                    self.noExistingContracts();
                } else {
                    self.renderListContracts();
                }

                self.aContractsGrouped = {
                    'contracts': self.aContractsGrouped,
                };

                self.renderHeadlineContracts();

            }
        },

        renderDataResult: function() {

            const self = this;

            $('.box24VsIpss', this.domContext).trigger('c24IpssActive');

            if (!self.isValidApiResponse(self.aApiDataResult)) {
                self.showDefaultTeaser(self);
                return;
            }

            self.renderList();
        },

        // eslint-disable-next-line no-unused-vars
        customLastSearchRendering: function (lastSearchElement, data) {
        //placeholder to handle custom rendering if needed
        },

        // eslint-disable-next-line no-unused-vars
        customIpssRendering: function (ipssElement, data) {
        //placeholder to handle custom rendering if needed
        },

        isValidApiResponse: function(data) {
            const self = this;

            if (self.bShowEverything) {

                if (!data.lastSearches && !data.contracts) {
                    return false;
                }

                let bReturnTestLastSearches = true;
                let bReturnTestNonContracts = true;

                if (!data.lastSearches || (typeof data.lastSearches != 'object') || !Array.isArray(data.lastSearches) || data.lastSearches.length < 1) {
                    bReturnTestLastSearches = false;
                }

                if (!data.contracts || (typeof data.contracts != 'object') || !Array.isArray(data.contracts) || data.contracts.length < 1) {
                    bReturnTestNonContracts = false;
                }

                if (!bReturnTestLastSearches && !bReturnTestNonContracts) {
                    return false;
                }

                return true;
            }

            if (!data || (typeof data !== 'object') || !Array.isArray(data) || data.length < 1) {
                return false;
            }

            return true;
        },

        isValidContractsGrouped: function(data) {

            if (!data || (typeof data != 'object') || !Array.isArray(data) || data.length < 1) {
                return false;
            }

            return true;
        },

        noExistingNonContracts: function() {
            const self = this;
            const $lastSearchesDummyContainer = $('[id^=lastSearches]', self.domContext);

            self.bNonContractsExists = false;

            self.addMissingInfo($lastSearchesDummyContainer, 'lastSearches');
            $lastSearchesDummyContainer.children('.ipssItemWrapper').remove();
        },

        noExistingContracts: function() {
            const self = this;
            const $contractsBox = $('[id^="contracts"][data-status=loggedIn]', self.domContext);

            self.bContractsExists = false;

            if ($contractsBox.length > 0) {
                self.addMissingInfo($contractsBox, 'contracts');
                $contractsBox.children('.ipssItemWrapper').remove();
            }
        },

        renderHeadlineNonContracts: function() {

            if ((this.counts.offersGroup + this.counts.lastSearches) > 0) {
                const $tabHeader = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', this.domContext);
                let tabHeaderText = 'Ihre letzten Aktivitäten';

                // No offers or incomplete contract => only last searches
                if (this.counts.offersGroup === 0) {

                    tabHeaderText = 'Ihr letzter Vergleich';
                    if (this.counts.lastSearches > 1) {
                        tabHeaderText = 'Ihre letzten Vergleiche';
                    }

                // no last searches => then we have either offers and/or incomplete contracts
                } else if (this.counts.lastSearches === 0) {

                    if (this.counts.offers > 0 && (this.aNoneContractTypes.indexOf('incompleteContract') === -1 || this.counts.incompleteContracts === 0)) {
                        tabHeaderText = this.counts.offers > 1 ? 'Ihre letzten Angebote' : 'Ihr letztes Angebot';
                    }

                    if (this.counts.incompleteContracts > 0 && (this.aNoneContractTypes.indexOf('offer') === -1 || this.counts.offers === 0)) {
                        tabHeaderText = this.counts.incompleteContracts > 1 ? 'Ihre letzten Anträge' : 'Ihr letzter Antrag';
                    }
                }

                const lastSearchesTabHeadline = tabHeaderText + ' <span id="lastsearches-counter"></span>';
                $tabHeader.html(lastSearchesTabHeadline);
            }


            let $offerHeadline = $('.cssTabContentBox[id^="lastSearches"] .ipssHeadline:not(.showEverything)', this.domContext);
            const $lastSearchesHeadline = $('.cssTabContentBox[id^="lastSearches"] .ipssHeadline.showEverything', this.domContext);

            if (this.counts.lastSearches > 0) {
                $lastSearchesHeadline.text(
                    (this.counts.lastSearches > 1) ? 'Ihre letzten Vergleiche' : 'Ihr letzter Vergleich',
                );
            } else {
                $lastSearchesHeadline.addClass('c24Hidden');
            }

            if (this.counts.offersGroup > 0) {

                if ($offerHeadline.length === 0) {
                    $offerHeadline = $('<div class="ipssHeadline"></div>');
                    $('.cssTabContentBox[id^="lastSearches"]', this.domContext).prepend($offerHeadline);
                }

                let headlineText = 'Ihre Aktivitäten';

                if (this.counts.offers > 0 && (this.aNoneContractTypes.indexOf('incompleteContract') === -1 || this.counts.incompleteContracts === 0)) {
                    headlineText = this.counts.offers > 1 ? 'Ihre Angebote' : 'Ihr Angebot';
                }

                if (this.counts.incompleteContracts > 0 && (this.aNoneContractTypes.indexOf('offer') === -1 || this.counts.offers === 0)) {
                    headlineText = this.counts.incompleteContracts > 1 ? 'Ihre Anträge' : 'Ihr Antrag';
                }

                $offerHeadline.text(headlineText);

            } else {

                $offerHeadline.addClass('c24Hidden');
                if (this.hasContractsTab()) {
                    $('.cssTabContentBox[id^="lastSearches"] .ipssHeadline.showEverything', this.domContext).addClass('c24Hidden');
                    $('.cssTabContentBox[id^="lastSearches"] .ipssHeadline.showEverything', this.domContext).hide();
                }

            }
        },

        renderHeadlineContracts: function() {
            let text = 'Ihr Vertrag';

            if (this.counts.contractsGroup > 1) {
                text = 'Ihre Verträge';
            }

            $('.cssTabHeaderItem[data-contentbox^="contracts"]', this.domContext)
                .html(text + ' <span id="contracts-counter"></span>');

            if (this.hasLastsearchesTab()) {
                $('.cssTabContentBox[id^="contracts"] .ipssHeadline', this.domContext).addClass('c24Hidden');
            } else {
                $('.cssTabContentBox[id^="contracts"] .ipssHeadline', this.domContext).text(text);
                $('.cssTabContentBox[id^="contracts"] .ipssHeadline', this.domContext).removeClass('c24Hidden');
            }
        },

        renderList: function() {
            const self = this;

            // if the list had been already rendered before, clear it
            if (self.bClonedElementNonContracts) {
                if (self.bShowContracts) {
                // remove only nonContracts blocks
                    $('.cssTabContentBox[id^=lastSearches] .ipssItem', self.domContext).remove();
                } else {
                    $('.ipssItemWrapper .ipssItem', self.domContext).remove();
                }
            }

            if (self.bShowEverything) {
                let bLastSearchesRendered = false;
                let bNonContractsRendered = false;

                $.each(self.aNonContractsGrouped, function(key, value) {
                    if (key === 'lastSearches' || key === 'contracts') {
                        if (key === 'lastSearches') {
                            bLastSearchesRendered = true;
                            self.sRenderType = 'lastSearches';

                            if (value.length < 1) {
                                $('[id^="lastSearches"] .ipssHeadline.showEverything', self.domContext).remove();
                                $('[id^="lastSearches"] .ipssItemWrapper.showEverything', self.domContext).remove();
                            } else {
                                value.forEach(function(data) {
                                    self.buildNonContracts(data);
                                });
                            }
                        }

                        if (key === 'contracts') {

                            bNonContractsRendered = true;
                            self.sRenderType = 'nonContracts';

                            if (value.length < 1) {
                                $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', self.domContext).remove();
                                $('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', self.domContext).remove();
                            } else {
                                value.forEach(function(data) {
                                    self.buildNonContracts(data);
                                });
                            }
                        }
                    }
                });

                if (bNonContractsRendered === false) {
                    $('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', this.domContext).remove();
                    $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', this.domContext).remove();
                }

                if (bLastSearchesRendered === false) {
                    $('[id^="lastSearches"] .ipssItemWrapper.showEverything', this.domContext).remove();
                    $('[id^="lastSearches"] .ipssHeadline.showEverything', this.domContext).remove();
                }
            } else {

                this.aNonContractsGrouped.forEach(function(data) {
                // show only one type of contracts
                    if (self.sRenderType !== 'lastSearches' && data.type !== self.sRenderType) {
                        return;
                    }

                    self.buildNonContracts(data);
                });
            }
        },

        renderListContracts: function() {
            const self = this;

            self.sRenderType = 'contract';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementContracts) {
            // remove only contract blocks
                $('.cssTabContentBox[id^=contracts] .ipssItem', self.domContext).remove();
            }

            this.aContractsGrouped.forEach(function(data) {
                self.buildContracts(data);
            });
        },

        buildNonContracts: function(data) {
            const self = this;
            const element = self.createNonContract();
            const dataPromise = self.renderDataArray(data);

            dataPromise.then(function(data) {
                self.renderElement(element, data);
            });
        },

        buildContracts: function(data) {
            const self = this;
            const element = self.createContract(data);
            const dataPromise = self.renderDataArrayContract(data);

            dataPromise.then(function(data) {
                self.renderElement(element, data);
            });
        },

        createNonContract: function() {
            const self = this;
            let newElement;

            if (!self.bClonedElementNonContracts) {

                if (self.bShowEverything) {

                    self.oElementTemplateLastSearches = $('[id^="lastSearches"] .ipssItemWrapper.showEverything .ipssItem.lastSearches', self.domContext).clone();
                    $('.ipssItemWrapper.showEverything .ipssItem.lastSearches', self.domContext).remove();

                    self.oElementTemplateArrangement = $('[id^="lastSearches"] .ipssItemWrapper .ipssItem.arrangement', self.domContext).clone();
                    $('[id^="lastSearches"] .ipssItem.arrangement', self.domContext).remove();

                } else {

                    self.oElementTemplateLastSearches = $('[id^="lastSearches"] .ipssItem.lastSearches', self.domContext).clone();
                    $('.ipssItem.lastSearches', self.domContext).remove();

                    self.oElementTemplateArrangement = $('[id^="lastSearches"] .ipssItem.arrangement', self.domContext).clone();
                    $('[id^="lastSearches"] .ipssItem.arrangement', self.domContext).remove();
                }

                self.bClonedElementNonContracts = true;
            }

            if (self.bShowEverything) {
                if (self.sRenderType === 'lastSearches') {
                    $('.showEverything', self.domContext).show();

                    newElement = self.oElementTemplateLastSearches.clone();
                    newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper.showEverything', self.domContext));

                } else {
                    if ($('.ipssItemWrapper.showEverything .ipssItem', self.domContext).length < 1) {
                        $('.showEverything', self.domContext).hide();
                    }

                    $('.ipssItemWrapper:not(.showEverything) .ipssItem.lastSearches', self.domContext).remove();

                    newElement = self.oElementTemplateArrangement.clone();
                    newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', self.domContext));
                }
            } else {
                $('.showEverything', self.domContext).hide();

                if (self.sRenderType === 'lastSearches') {
                    newElement = self.oElementTemplateLastSearches.clone();
                } else {
                    newElement = self.oElementTemplateArrangement.clone();
                }
                newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', this.domContext));
            }
            return newElement.addClass('no-data c24Hidden');
        },

        buildElement: function(data) {
            const self = this;
            const element = self.createElement(data);
            const dataPromise = self.renderDataArray(data);

            dataPromise.then(function(data) {
                self.renderElement(element, data);
            });
        },

        createElement: function(data) {
            const self = this;
            let newElement;

            if (!self.bClonedElementTemplates) {

                if (self.bShowEverything) {

                    this.oElementTemplateLastSearches = $('[id^="lastSearches"] .ipssItemWrapper.showEverything .ipssItem.lastSearches', this.domContext).clone();
                    $('.ipssItemWrapper.showEverything .ipssItem.lastSearches', this.domContext).remove();

                    this.oElementTemplateArrangement = $('[id^="lastSearches"] .ipssItemWrapper .ipssItem.arrangement', this.domContext).clone();
                    $('[id^="lastSearches"] .ipssItem.arrangement', this.domContext).remove();

                    this.oElementTemplateArrangementContract = $('[id^="contracts"] .ipssItemWrapper .ipssItem.contract', this.domContext).clone();
                    $('[id^="contracts"] .ipssItem.contract', this.domContext).remove();

                    this.oElementTemplateArrangementForeignContract = $('[id^="contracts"] .ipssItemWrapper' +
                                                                 ' .ipssItem.foreignContract', this.domContext).clone();
                    $('[id^="contracts"] .ipssItem.foreignContract', this.domContext).remove();

                } else {

                    this.oElementTemplateLastSearches = $('[id^="lastSearches"] .ipssItem.lastSearches', this.domContext).clone();
                    $('.ipssItem.lastSearches', this.domContext).remove();

                    this.oElementTemplateArrangement = $('[id^="lastSearches"] .ipssItem.arrangement', this.domContext).clone();
                    $('[id^="lastSearches"] .ipssItem.arrangement', this.domContext).remove();
                }

                self.bClonedElementTemplates = true;
            }

            if (self.bShowEverything) {

                if (self.sRenderType === 'lastSearches') {

                    $('.showEverything', this.domContext).show();

                    newElement = this.oElementTemplateLastSearches.clone();
                    newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper.showEverything', this.domContext));

                } else {

                    if ($('.ipssItemWrapper.showEverything .ipssItem', this.domContext).length < 1) {
                        $('.showEverything', this.domContext).hide();
                    }

                    $('.ipssItemWrapper:not(.showEverything) .ipssItem.lastSearches', this.domContext).remove();

                    newElement = this.oElementTemplateArrangement.clone();

                    let itemWrapper = $('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', this.domContext);

                    if (self.isExtendedIpss() && (data.type === 'contract' || data.type === 'foreignContract')) {
                        itemWrapper = $('[id^="contracts"] .ipssItemWrapper:not(.showEverything)', this.domContext);
                        newElement = this.oElementTemplateArrangementContract.clone();
                    }

                    newElement.appendTo(itemWrapper);
                }
            } else {
                $('.showEverything', this.domContext).hide();

                if (self.sRenderType === 'lastSearches') {
                    newElement = this.oElementTemplateLastSearches.clone();
                } else {
                    newElement = this.oElementTemplateArrangement.clone();
                }
                newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper:not(.showEverything)', this.domContext));
            }
            return newElement.addClass('no-data c24Hidden');
        },

        createContract: function(data) {
            const self = this;
            let newElement;
            const type = data.type;

            if (!self.bClonedElementContracts) {
            // @todo after a few weeks (from 17.06.2021) on, you should use '.contract' instead of the ':not()'-thingy
            // we just have to give the products some time to export+release the new classes.
                self.oElementTemplateContract = $('[id^="contracts"] .ipssItem:not(.foreignContract)', self.domContext).clone();
                $('[id^="contracts"] .ipssItem:not(.foreignContract)', self.domContext).remove();

                self.oElementTemplateForeignContract = $('[id^="contracts"] .ipssItem.foreignContract', self.domContext)
                    .clone();
                $('[id^="contracts"] .ipssItem.foreignContract', self.domContext).remove();

                self.bClonedElementContracts = true;
            }

            switch (type) {
                case 'foreignContract':
                    newElement = self.oElementTemplateForeignContract.clone();
                    break;
                case 'contract':
                default:
                    newElement = self.oElementTemplateContract.clone();
                    break;
            }


            newElement.appendTo($('[id^="contracts"] .ipssItemWrapper', this.domContext));

            return newElement.addClass('no-data c24Hidden');
        },

        renderDataArray: function(data) {
            const self = this;
            const aDataArray = {};

            if (!data) {
                return false;
            }

            const ret = $.Deferred();

            if (self.sRenderType === 'lastSearches') {
                const dataResult = data.result;

                // create Array for lastSearches
                $.extend(aDataArray, self.renderDataArrayCategoryType()); // set category value
                $.extend(aDataArray, self.renderDataArrayIcons(dataResult.inputs)); // icons
                $.extend(aDataArray, self.renderDataArrayLabels(dataResult)); // persons
                $.extend(aDataArray, self.renderDataArrayMetaData(data)); // device & timestamp
                $.extend(aDataArray, self.renderDataArrayTariffDetails(dataResult.tariff)); // tariff
                $.extend(aDataArray, self.renderDataArrayCta(dataResult.cta)); // cta
                $.extend(aDataArray, self.renderDataArrayLinking(dataResult)); // delete url

                // set insuranceName
                if (dataResult.inputs.insuranceKey) {
                    $.ajax({
                        dataType: 'json',
                        url: '/versicherungsordner/api/insurance-service/insurances/' + dataResult.inputs.insuranceKey + '/',
                        contentType: 'application/json; charset=UTF-8',
                        cache: true,
                        timeout: 4000,
                    }).done(function(data) {
                        aDataArray.labels.insuranceName = data.data.name;
                    }).fail(function() {
                        aDataArray.labels.insuranceName = null;
                    }).always(function() {
                        ret.resolve(aDataArray);
                    });
                } else {
                    aDataArray.labels.insuranceName = null;

                    ret.resolve(aDataArray);
                }

            } else {
            // create array for incompleteContracts and offers
                $.extend(aDataArray, self.renderDataArrayCategoryType(data.type)); // set category value
                $.extend(aDataArray, self.renderDataArrayProductSpecificData(data)); // productSpecificData
                $.extend(aDataArray, self.renderDataArrayIcons(data.insuranceKey)); // insurance key for icon
                $.extend(aDataArray, self.renderDataArrayLabels(data)); // insurance key for name
                $.extend(aDataArray, self.renderDataArrayMetaData(data)); // status
                $.extend(aDataArray, self.renderDataArrayTariffDetails(data.tariff)); // tariff
                $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
                $.extend(aDataArray, self.renderDataArrayLinking(data));

                // set insuranceName
                if (data.insuranceKey) {
                    $.ajax({
                        dataType: 'json',
                        url: '/versicherungsordner/api/insurance-service/insurances/' + data.insuranceKey + '/',
                        contentType: 'application/json; charset=UTF-8',
                        cache: true,
                        timeout: 4000,
                    }).done(function(data) {
                        aDataArray.labels.insuranceName = data.data.name;
                    }).fail(function() {
                        aDataArray.labels.insuranceName = null;
                    }).always(function() {
                        ret.resolve(aDataArray);
                    });
                }
            }

            return ret.promise();
        },

        renderDataArrayContract: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            $.extend(aDataArray, self.renderDataArrayCategoryType(data.type)); // set category value
            $.extend(aDataArray, self.renderDataArrayIcons(data.insuranceKey)); // insurance key for icon
            $.extend(aDataArray, self.renderDataArrayLabels(data)); // insurance key for name
            $.extend(aDataArray, self.renderDataArrayMetaData(data)); // status
            $.extend(aDataArray, self.renderDataArrayTariffDetails(data.tariff)); // tariff
            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));

            // set insuranceName
            if (data.insuranceKey) {
                $.ajax({
                    dataType: 'json',
                    url: '/versicherungsordner/api/insurance-service/insurances/' + data.insuranceKey + '/',
                    contentType: 'application/json; charset=UTF-8',
                    cache: true,
                    timeout: 4000,
                }).done(function(data) {
                    aDataArray.labels.insuranceName = data.data.name;
                }).fail(function() {
                    aDataArray.labels.insuranceName = null;
                }).always(function() {
                    ret.resolve(aDataArray);
                });
            }

            return ret.promise();
        },

        formatPrice: function(iPrice, sPriceUnit, bDecimalSeparator, bPriceInCents, thousandsSeparator) {
            let rawPrice;
            let sPrice;

            sPriceUnit = typeof sPriceUnit !== 'undefined' ? this.priceUnitMap[sPriceUnit] : this.priceUnitMap.euro;
            bPriceInCents = typeof bPriceInCents !== 'undefined' ? bPriceInCents : this.bPriceInCents;
            bDecimalSeparator = typeof bDecimalSeparator !== 'undefined' ? bDecimalSeparator : this.bDecimalSeparator;
            thousandsSeparator = typeof thousandsSeparator !== 'undefined' ? thousandsSeparator : this.bThousandsSeparator;

            if (bPriceInCents) {
                rawPrice = iPrice / 100;
            } else {
                rawPrice = iPrice;
            }

            if (bDecimalSeparator === true) {
                sPrice = rawPrice.toFixed(2).replace('.', ',');
            } else {
                sPrice = rawPrice.toFixed().replace('.', ',');
            }


            if (thousandsSeparator === true) {
                sPrice = sPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }

            sPrice += ' ' + sPriceUnit;

            return sPrice;
        },

        fnValueMerge: function(input, fieldname) {
            const arrayInput = Array.isArray(input) ? input : [input];

            return arrayInput.reduce(function(accumulator, currentValue, index) {
                if (!currentValue[fieldname]) {
                    return null;
                }

                if (accumulator === null) {
                    return null;
                }

                if (index === 0) {
                    return currentValue[fieldname];
                }
                return accumulator + ', ' + currentValue[fieldname];
            }, '');
        },

        renderDataArrayCategoryType: function(data) {
            const aDataArray = {};

            if (!data) {
                aDataArray.categoryType = 'lastSearches';
            } else {
                aDataArray.categoryType = data;
            }

            return aDataArray;
        },

        renderDataArrayIcons: function(data) {
            const self = this;
            let icon = '';
            const personGroupKey = data.personGroupKey;
            let aPersons = data.persons;
            const aDataArray = {};

            aDataArray.icon = { };

            aPersons = aPersons || null;

            if (self.sRenderType === 'lastSearches') {
                let iconKey = '';

                if (personGroupKey) {
                    iconKey = personGroupKey;

                } else if (aPersons && aPersons[0]) {
                    iconKey = aPersons[0].type;
                }

                icon = this.iconMap[iconKey];

                if (!icon) {
                    icon = '';
                }

                aDataArray.icon.iconKey = iconKey;
            } else {
                icon = '/versicherungsordner/api/insurance-service/insurances/' + data + '/logo';
            }

            aDataArray.icon.html = icon;

            return aDataArray;
        },

        renderDataArrayLabels: function(data) {
            const self = this;
            const aDataArray = {};

            aDataArray.labels = { };

            if (data.actionMark) {
                aDataArray.actionMark = data.actionMark;
            }

            // set personCount, personType, personJob, personBirth
            if (data.inputs && data.inputs.persons) {
                let childCounter = 0;
                let persons;

                if (self.filterPersons) {
                    persons = self.filterPersons(data.inputs.persons);
                } else {
                    persons = data.inputs.persons;
                }

                if (persons.length > 1) {
                    let personList = '';

                    persons.map(function(person) {
                        return person.type;
                    }).forEach(function(personType) {
                        if (personType === 'Kind') {
                            childCounter++;
                        } else {
                            if (personList !== '') {
                                personList += ', ';
                            }
                            personList += personType;
                        }
                    });

                    if (childCounter > 1) {
                        if (personList !== '') {
                            personList += ', ';
                        }
                        personList += childCounter + ' Kinder';
                    } else if (childCounter > 0) {
                        if (personList !== '') {
                            personList += ', ';
                        }
                        personList += 'Kind';
                    }

                    aDataArray.labels.personCount = persons.length + ' Personen';

                    aDataArray.labels.personType = personList;

                } else {
                    aDataArray.labels.personCount = persons.length + ' Person';

                    if (self.bCommaAfterPersonType) {
                        aDataArray.labels.personType = persons[0].type + ', ';
                    } else {
                        aDataArray.labels.personType = persons[0].type;
                    }

                    if (persons[0].job) {
                        if (self.bCommaAfterPersonJob) {
                            aDataArray.labels.personJob = persons[0].job + ', ';
                        } else {
                            aDataArray.labels.personJob = persons[0].job;
                        }
                    } else {
                        aDataArray.labels.personJob = null;
                    }

                    if (persons[0].birthday) {
                        aDataArray.labels.personBirth = persons[0].birthday;
                    } else {
                        aDataArray.labels.personBirth = null;
                    }
                }
            }

            // set tariffName
            if (data.tariff.name) {
                aDataArray.labels.tariffName = data.tariff.name;
            }

            // set insuredPerson
            if (data.insuredPerson) {
                const personCount = data.insuredPerson.length;
                let i = 1;

                aDataArray.labels.insurePersonName = '';

                data.insuredPerson.forEach(function(data) {
                    if (data.name) {
                        if (i < personCount) {
                            aDataArray.labels.insurePersonName += data.name + ', ';
                        } else {
                            aDataArray.labels.insurePersonName += data.name;
                        }
                    }

                    i++;
                });
            }

            // set note
            if (data.info) {
                aDataArray.labels.note = data.info;
            } else {
                aDataArray.labels.note = null;
            }

            return aDataArray;
        },

        renderedDeviceLabel: function(deviceOutput) {

            // set deviceoutput
            if (deviceOutput !== null) {

                if (deviceOutput === 'mobile') {
                    return 'auf dem Handy';
                } else if (deviceOutput === 'app' || deviceOutput === 'tabletapp') {
                    return 'in der App';
                } else if (deviceOutput === 'tablet') {
                    return 'auf dem Tablet';
                } else {
                    return 'auf dem PC/Laptop';
                }

            } else {
                return null;
            }

        },

        renderDataArrayMetaData: function(data) {
            const aDataArray = {};
            const time = data.time;
            let deviceOutput = null;
            const status = (data.status) ? data.status : null;
            const type = (data.type) ? data.type : null;

            if (data.deviceOutput) {
                deviceOutput = data.deviceOutput;
            } else if (data.deviceoutput) {
                deviceOutput = data.deviceoutput;
            } else {
                deviceOutput = null;
            }

            aDataArray.metaData = { };

            // set timestamp
            if (time !== null) {
                const dTimestamp = new Date((time) * 1000);
                const iDay = ('0' + dTimestamp.getDate()).slice(-2);
                const iMonth = ('0' + (dTimestamp.getMonth() + 1)).slice(-2);
                const iFullDate = iDay + '.' + iMonth + '.' + dTimestamp.getFullYear();

                if ((window.c24LpTime - time) < 3600) {
                    aDataArray.metaData.timestamp = 'vor Kurzem';
                } else if ((window.c24LpTime - time) < 86400) {
                    const diffHours = Math.floor((window.c24LpTime - time) / 3600);
                    let placeholder = '';

                    if (diffHours > 1) {
                        placeholder = 'Stunden';
                    } else {
                        placeholder = 'Stunde';
                    }

                    aDataArray.metaData.timestamp = 'vor ' + diffHours + ' ' + placeholder;
                } else {
                    aDataArray.metaData.timestamp = 'am ' + iFullDate;
                }
            }

            // set deviceoutput
            if (deviceOutput !== null) {
                if (deviceOutput === 'mobile') {
                    aDataArray.metaData.device = 'auf dem Handy';
                } else if (deviceOutput === 'app' || deviceOutput === 'tabletapp') {
                    aDataArray.metaData.device = 'in der App';
                } else if (deviceOutput === 'tablet') {
                    aDataArray.metaData.device = 'auf dem Tablet';
                } else {
                    aDataArray.metaData.device = 'auf dem PC/Laptop';
                }
            } else {
                aDataArray.metaData.device = null;
            }

            // set status info
            if (status !== null) {
                aDataArray.metaData.statusText = status.text;
                aDataArray.metaData.statusColor = status.color;
            }

            // set type
            let textBeginning;

            if (type !== null) {
                textBeginning = this.timeWordingMap[type];
            } else {
                textBeginning = 'verglichen';
            }

            aDataArray.metaData.textBeginning = textBeginning;

            return aDataArray;
        },

        renderDataArrayTariffDetails: function(data) {
            const self = this;
            const price = data.price !== undefined ? data.price : data.best.price;
            let priceUnit;
            const period = data.period !== undefined ? data.period : data.best.period;
            const aDataArray = {};

            aDataArray.tariff = {};

            // set count
            if (data.count) {
                if (data.count === 1) {
                    aDataArray.tariff.count = data.count + ' Tarif ab';
                } else {
                    aDataArray.tariff.count = data.count + ' Tarife ab';
                }
            }

            // set priceUnit
            if (data.priceUnit != null) {
                priceUnit = data.priceUnit;
            } else if (data.best && data.best.priceUnit) {
                priceUnit = data.best.priceUnit;
            } else {
                priceUnit = this.defaultPriceUnit;
            }

            // set price
            if (price) {
                aDataArray.tariff.price = self.formatPrice(price, priceUnit);
            } else {
                aDataArray.tariff.price = null;
            }

            // set period
            if (period) {
                aDataArray.tariff.period = this.periodMap[period];
            } else {
                aDataArray.tariff.period = null;
            }

            return aDataArray;
        },

        renderDataArrayCta: function(dataCta) {
            const self = this;
            const aDataArray = {};
            let urlDesktop;
            let urlMobile;

            aDataArray.cta = {
                'primary': null,
                'secondary': null,
                'tertiary': null,
            };

            if (self.sRenderType === 'lastSearches') {
                if (dataCta.url_desktop) {
                    urlDesktop = dataCta.url_desktop;
                } else {
                    urlDesktop = dataCta.urlDesktop;
                }

                if (dataCta.url_mobile) {
                    urlMobile = dataCta.url_mobile;
                } else {
                    urlMobile = dataCta.urlMobile;
                }

                aDataArray.cta.primary = {
                    'text': dataCta.text,
                    'urlDesktop': urlDesktop,
                    'urlMobile': urlMobile,
                };
            } else {
                $.each(dataCta, function(key, value) {
                    if (value.url_desktop) {
                        urlDesktop = value.url_desktop;
                    } else {
                        urlDesktop = value.urlDesktop;
                    }

                    if (value.url_mobile) {
                        urlMobile = value.url_mobile;
                    } else {
                        urlMobile = value.urlMobile;
                    }

                    aDataArray.cta[value.type] = {
                        'text': value.text,
                        'urlDesktop': urlDesktop,
                        'urlMobile': urlMobile,
                    };
                });
            }

            return aDataArray;
        },

        renderDataArrayLinking: function(data) {
            const aDataArray = {};
            let urlDelete = null;

            if (data && data.url_delete) {
                urlDelete = data.url_delete;
            } else if (data && data.urlDelete) {
                urlDelete = data.urlDelete;
            }

            if (urlDelete === null) {
                return aDataArray;
            }

            aDataArray.urlDelete = urlDelete;

            return aDataArray;
        },

        renderDataArrayProductSpecificData: function (data) {

            const aDataArray = {
                productSpecificData: {},
            };

            if ('productSpecificData' in data) {
                aDataArray.productSpecificData = data.productSpecificData;
            }

            return aDataArray;
        },

        renderElement: function(element, data) {
            const self = this;

            if (data.categoryType) {
                self.renderCategoryType(element, data);
            }

            if (data.icon) {
                self.renderIcons(element, data);
            }

            if (data.labels) {
                self.renderLabels(element, data);
            }

            if (data.metaData) {
                self.renderMetaData(element, data);
            }

            if (data.tariff) {
                self.renderTariffDetails(element, data);
            }

            if (data.cta) {
                self.renderCta(element, data);
            }

            self.renderLinking(element, data);

            $(element).removeClass('no-data c24Hidden');

            // wait till showIpssTeaser is finished
            $.when(self.renderingDone).done(function() {
                if (data.tooltips) {
                    self.renderTooltips(element, data);
                }

                if (data.categoryType === 'lastSearches') {
                    self.customLastSearchRendering(element, data);
                } else {
                    self.customIpssRendering(element, data);
                }

            });
        },

        renderCategoryType: function(element, data) {
            $(element).data('category', data.categoryType);
        },

        renderIcons: function(element, data) {
            const iconContainer = $('.iconContainer', element);

            if (data.icon.iconKey) {
                iconContainer.html(data.icon.html).attr('data-type', data.icon.iconKey);
            } else {
                iconContainer.css({
                    'background-image': 'url("' + data.icon.html + '")',
                });
            }

        },

        renderLabels: function(element, data) {
            $.each(data.labels, function(key, value) {
                if (value != null) {
                    $('.' + key, element).html($.parseHTML(value));
                } else {
                    $('.' + key, element).remove();
                }
            });
        },

        renderMetaData: function(element, data) {
            $.each(data.metaData, function(key, value) {
                if (key.match('^status')) {
                    if (key.match('Text$')) {
                        $('.status', element).text(value);
                    }
                    if (key.match('Color$') && value) {
                        if (value.charAt(0) === '#') {
                            $('.status', element).css('color', value);
                        } else {
                            $('.status', element).addClass(value);
                        }
                    }
                } else {
                    if (value != null) {
                        $('.' + key, element).text(value);
                    } else {
                        $('.' + key, element).remove();
                    }
                }
            });
        },

        renderTariffDetails: function(element, data) {
            $.each(data.tariff, function(key, value) {
                key = key.charAt(0).toUpperCase() + key.slice(1);

                if (value === null) {
                    $('.tariff' + key, element).remove();
                } else {
                    $('.tariff' + key, element).text(value);
                }
            });
        },

        renderCta: function(element, data) {
            if (this.bIsMobile) {
                $('.js24ButtonCompare', element).attr('href', data.cta.primary.urlMobile);

                element.data('linking', data.cta.primary.urlMobile);

                if ($('.ctaButtonContainer .js24ButtonCompare.primary', element)) {
                    $('.ctaButtonContainer .js24ButtonCompare.primary', element).html(data.cta.primary.text);
                }

            } else {
                $.each(data.cta, function(key, value) {
                    if (value == null) {
                        $('.js24ButtonCompare.' + key, element).remove();
                    } else {
                        $('.js24ButtonCompare.' + key, element).attr('href', value.urlDesktop).html(value.text + '<span class="js24LoadingAction"></span>');
                    }

                    if (key === 'primary' && element.hasClass('lastSearches')) {
                        element.data('linking', value.urlDesktop);
                    }
                });
            }
        },

        renderLinking: function(element, data) {
            const self = this;

            if (this.bIsMobile) {
                $('.metaData', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const jSelf = $(this);

                    if (jSelf.data('deletelink')) {
                        self.removeIpssItem(jSelf, self);
                    }

                    return false;
                });

            } else {
                $('.delete', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const jSelf = $(this);
                    self.removeIpssItem(jSelf, self);

                    return false;
                });
            }

            $('.c24Tooltip , .js24VsIpssTooltip', element).on('click', function(e) {
                e.stopPropagation();
                return false;
            });

            $('.js24ButtonCompare.primary, .js24ButtonCompare.secondary, .js24ButtonCompare.tertiary', element)
                .on('click', function (e) {
                    e.stopPropagation();

                    $(this).trigger('c24Tracking');
                });

            element.on('click', function(e) {
                e.preventDefault();

                const dataLinking = $(this).data('linking');

                if (dataLinking != null) {
                    window.location.href = dataLinking;
                }
            });

            const metaDataContainer = $('.metaData', element);

            if (data.urlDelete != null) {
                if (this.bIsMobile) {
                    metaDataContainer.data('deletelink', data.urlDelete);
                } else {
                    if ($('.delete', metaDataContainer).length > 0) {
                        $('.delete', metaDataContainer).data('deletelink', data.urlDelete);
                    } else {
                        $('.delete', element).data('deletelink', data.urlDelete);
                    }
                }
            } else {
                if (this.bIsMobile) {
                    $('.delete', metaDataContainer).remove();
                } else {
                    if ($('.delete', metaDataContainer).length > 0) {
                        $('.delete', metaDataContainer).remove();
                    } else {
                        $('.delete', element).remove();
                    }
                }
            }
        },

        renderTooltips: function(element, data) {

            if (data.tooltips.labels) {
                data.tooltips = data.tooltips.labels;
            }

            $.each(data.tooltips, function(key, value) {
                if (value != null) {
                    $('.c24TooltipPopup .' + key, element).html($.parseHTML(value));
                } else {
                    $('.c24TooltipPopup .' + key, element).remove();
                }
            });

            // create tooltip
            if (!window.c24LpIsMobile) {
                const $el = $('.c24Tooltip', element);
                // There is only one #c24-content on the page, since it's an ID. So no need for domContext.
                // Since you're reading comments: don't forget about /versicherungen, what ever you're doing here.
                const ac = $('#c24-content');
                let arrowPosition;
                let parentPosition;

                if ($el.offset().left + ($el.width() / 2) > ac.offset().left + (ac.width() / 2)) {
                    arrowPosition = 'right center';
                    parentPosition = 'left center';
                } else {
                    arrowPosition = 'left center';
                    parentPosition = 'right center';
                }

                $('.c24Tooltip', element).qtip({
                    content: {
                        text: $('.c24TooltipPopup', element).html(),
                        button: (window.c24LpNotPinnedQtip ? null : 'Schließen'),
                    },
                    style: {
                        classes: 'ipssTooltip ppset fade ffmham ' + this.prefix + ' ' + (window.c24LpNotPinnedQtip ? '' : ' closable'),
                        tip: {
                            border: 1,
                            width: 16,
                            height: 9,
                        },
                    },
                    show: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseenter' : 'click focus'),
                    },
                    hide: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseleave focusout' : ''),
                        fixed: true,
                        delay: 500,
                    },
                    position: {
                        viewport: $('html'),
                        // Position of the arrow
                        my: arrowPosition,
                        // Position relative to the parent element
                        at: parentPosition,
                        adjust: {
                            method: (((parentPosition === 'left center' || parentPosition === 'right center') && $(this).closest('.qtipWrapper')) ? 'none none' : 'shift flip'),
                        },
                    },
                    events: {
                        render: function(event, api) {
                            window.c24OnRenderQtip(event, api);
                        },

                        move: function(_, api, position) {
                            window.c24RepositionQTip(api, position);
                        },
                    },
                });
            } else {
                $('.js24VsIpssTooltip', element).click(function () {
                    const html = $('.c24TooltipPopup', element).html();

                    $('.js24InfoPopupContent').html(html + '<div class="ico24CloseMobile"></div>');

                    $('.div24Popup .box24Background, .div24Popup .ico24CloseMobile').click(function() {
                        $('.div24Popup').hide();
                    });

                    $('.div24InfoPopup').show();
                });
            }
        },

        /**
     * Removes an ipss item
     */
        removeIpssItem: function (currentElement, outerSelf) {

            const self = this;
            const $ipssItem = currentElement.closest('.ipssItem');
            const type = $ipssItem.data('category');
            const deleteUrl = currentElement.data('deletelink');
            const deleteId = currentElement.data('deleteId') || null;
            let currentCount = 0;

            $(currentElement, this.domContext).trigger('c24IpssDelete');

            $.ajax({
                url: deleteUrl,
                type: outerSelf.sDeleteMethod,
                xhrFields: {
                    withCredentials: true,
                },
                cache: false,
            });

            switch (type) {
                case 'lastSearches':
                    this.counts.lastSearches--;
                    currentCount = this.counts.lastSearches;
                    break;
                case 'offer':
                    this.counts.offers--;
                    currentCount = this.counts.offers;
                    break;
                case 'incompleteContract':
                    this.counts.incompleteContracts--;
                    currentCount = this.counts.incompleteContracts;
                    break;
                case 'contract':
                case 'foreignContract':
                default:
                    this.counts.contracts--;
                    currentCount = this.counts.contracts;
            }

            if (this.aNoneContractTypes.indexOf(type) > -1) {
                this.counts.offersGroup--;
                currentCount = this.counts.offersGroup;
            } else if (this.aContractTypes.indexOf(type) > -1) {
                this.counts.contractsGroup--;
                currentCount = this.counts.contractsGroup;
            }

            const totalCount = this.counts.lastSearches + this.counts.offersGroup + this.counts.contractsGroup;

            if (currentCount > 0) {

                // Only remove this item
                $ipssItem.stop().fadeOut(600, function () {
                    $(this).remove();
                });

                this.renderHeadlineContracts(deleteId);
                this.renderHeadlineNonContracts(deleteId);
                this.renderCounters(deleteId);

            } else if (totalCount > 0) {

                // Only remove wrapper and headline

                $ipssItem.closest('.ipssItemWrapper').stop().fadeOut(600, function () {
                    $(this).remove();
                });

                $ipssItem.closest('.ipssItemWrapper').prev('.ipssHeadline').stop().fadeOut(600, function () {
                    $(this).remove();
                });

                this.displayTabs(true);
                this.renderHeadlineContracts(deleteId);
                this.renderHeadlineNonContracts(deleteId);
                this.renderCounters();

            } else {
            // remove whole ipss container
                $ipssItem.closest('.box24VsIpssWrapper').stop().fadeOut(600, function () {
                    self.showDefaultTeaser(self);
                });
            }

        },
        /**
     * Displays the tabs
     */
        displayTabs: function (smooth) {

            const hasContracts = this.counts.contractsGroup > 0;
            const hasOffers = this.counts.offersGroup > 0;
            const hasLastSearches = this.counts.lastSearches > 0;
            const self = this;

            if (!hasContracts || (!hasOffers && !hasLastSearches)) {
            // Hide Tabs
                $('.cssTabHeaderContainer', this.domContext).addClass('c24Hidden');

                if (hasContracts) {

                    if (!smooth) {
                        $('.cssTabContentBox[id^="lastSearches"]', this.domContext).removeClass('active');
                        $('.cssTabContentBox[id^="contracts"]', this.domContext).addClass('active');
                    } else {
                        $('.cssTabContentBox[id^="lastSearches"]', this.domContext).stop().fadeOut(150, function () {
                            $('.cssTabContentBox[id^="contracts"]', self.domContext).stop().fadeIn(150);
                        });
                    }

                } else {

                    if (!smooth) {
                        $('.cssTabContentBox[id^="lastSearches"]', this.domContext).addClass('active');
                        $('.cssTabContentBox[id^="contracts"]', this.domContext).removeClass('active');
                    } else {
                        $('.cssTabContentBox[id^="contracts"]', this.domContext).stop().fadeOut(150, function () {
                            $('.cssTabContentBox[id^="lastSearches"]', self.domContext).stop().fadeIn(300);
                        });
                    }
                }
                return false;
            }
            return true;
        },

        /**
     * Renders the counters
     */
        renderCounters: function () {

            const lastSearchesCount = (this.counts.lastSearches + this.counts.offersGroup);
            let lastsearchesCounterText = '';
            let contractsCounterText = '';


            if (lastSearchesCount > 1 && !this.bIsMobile) {
                lastsearchesCounterText = '(' + lastSearchesCount + ')';
            }

            if (this.counts.contractsGroup > 1) {
                contractsCounterText = '(' + this.counts.contractsGroup + ')';
            }

            $('#lastsearches-counter', this.domContext).text(lastsearchesCounterText);
            $('#contracts-counter', this.domContext).text(contractsCounterText);
        },

        /**
     * Determines if the last searches tab should be shown
     */
        hasLastsearchesTab: function () {
            return (this.counts.offersGroup + this.counts.lastSearches) > 0;
        },

        /**
     * Determines if the contracts tab should be shown
     */
        hasContractsTab: function () {
            return this.counts.contracts > 0;
        },

        /**
     * Determines if the extended ipps should be shown
     */
        isExtendedIpss: function () {
            return $('.tabNavi', this.domContext).length > 0;
        },

        addMissingInfo: function(element, type) {
            const _aInfoTextMap = {
                'lastSearches': 'Noch keine Vergleiche vorhanden',
                'contracts': 'Keine Verträge vorhanden',
            };
            let _infoText = '';

            if (_aInfoTextMap[type]) {
                _infoText = _aInfoTextMap[type];
            }

            element
                .prepend('<div class="missingInfo">' + _infoText + '</div>')
                .addClass('missingEntries');
        },

        showDefaultTeaser: function(self) {
            const ac = $('.box24VsIpssWrapper', self.domContext).closest('.mod24ac');

            if (ac.hasClass('ipss')) {
                ac.removeClass('ipss');
            }

            if ($('.subhead.ipssDefaultSubHead', ac).length) {
                $('.subhead.ipssDefaultSubHead', ac).removeClass('c24Hidden');
                $('.subhead.ipssSubHead', ac).addClass('c24Hidden');
            }

            $('header h3.original', ac).removeClass('c24Hidden');
            $('.js24VsIpssDefaultTeaser', ac).removeClass('c24Hidden').show();
            $('.box24VsIpssWrapper', self.domContext).hide();

        },

        showIpssTeaser: function() {
            const self = this;

            const showTeaserFunc = function() {

                const ac = $('.box24VsIpssWrapper', self.domContext).closest('.mod24ac');

                if (!ac.hasClass('ipss')) {
                    ac.addClass('ipss');
                }

                if (self.bIsMobile) {
                    $('header h3', ac).addClass('original c24Hidden');
                }

                if (!$('.subhead.ipssDefaultSubHead', ac).length) {
                    const $subHeadClone = $('header > .subhead', ac).clone();
                    $('header > .subhead', ac).addClass('ipssDefaultSubHead c24Hidden').after($subHeadClone);
                }

                $('header > .subhead.ipssDefaultSubHead', ac).addClass('c24Hidden');
                $('header > .subhead.ipssSubHead', ac).removeClass('c24Hidden');

                self.renderingDone.resolve();
            };

            if (self.fadeTeaser) {

                $('.js24VsIpssDefaultTeaser', this.domContext).stop().fadeOut(self.fadeTeaserDelay, showTeaserFunc);

            } else {

                $('.js24VsIpssDefaultTeaser', this.domContext).hide();

                showTeaserFunc();
            }

            return self.renderingDone.promise();
        },

        isLoadedFromCache: function() {

            if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
                return true;
            }

            if (window.performance && window.performance.getEntriesByType) {
                const perfEntries = window.performance.getEntriesByType('navigation');

                if (perfEntries.length > 0 && perfEntries[0] && perfEntries[0].type === 'back_forward') {

                    return true;
                }
            }

            return false;
        },

        registerTabSwitchEvent: function() {
            const self = this;
            if (this.displayTabs()) {
                $('.cssTabHeaderContainer .cssTabHeaderItem', self.domContext).on('click', function() {
                    const $self = $(this);
                    if ($self.hasClass('active')) {
                        return;
                    }
                    $('.cssTabHeaderItem.active', self.domContext).removeClass('active');
                    $('.cssTabContentBox.active', self.domContext).removeClass('active');

                    $self.addClass('active');
                    $('#' + $self.data('contentbox')).addClass('active');
                });
            }
        },

        registerReloadIpssEvent: function() {

            if (this.bReloadIpssEventRegistered) {
                return;
            }

            this.bReloadIpssEventRegistered = true;

            const self = this;

            $(window).on('pageshow', function(e) {
                if (e.originalEvent.persisted) {
                    self.getAPiData(self.sLastUrl);
                }
            });
        },

        activateTracking: function() {
            const self = this;

            $('.box24VsIpss.js24VsIpss', this.domContext).on('c24IpssActive', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'active:ipss',
                    'ipss:' + self.sRenderType,
                ]);
            });

            $('.box24VsIpss', this.domContext).on('click c24Tracking', '.ipssItem .js24ButtonCompare', function() {
                const jSelf = $(this);
                const ipssItemCategory = jSelf.closest('.ipssItem').data('category');
                let actionName = '';
                let eventName = '';

                if (self.bIsMobile) {
                    if (ipssItemCategory === 'lastSearches') {
                        actionName = 'result';
                        eventName = 'result';
                    } else if (ipssItemCategory === 'offer') {
                        actionName = 'finish';
                        eventName = 'finish';
                    } else if (ipssItemCategory === 'incompleteContract') {
                        actionName = 'continue';
                        eventName = 'continue';
                    }
                } else {
                // tracking for primary button
                    if (jSelf.hasClass('primary')) {
                        if (ipssItemCategory === 'lastSearches') {
                            actionName = 'result';
                            eventName = 'result';
                        } else if (ipssItemCategory === 'offer') {
                            actionName = 'finish';
                            eventName = 'finish';
                        } else if (ipssItemCategory === 'incompleteContract') {
                            actionName = 'continue';
                            eventName = 'continue';
                        }
                    }

                    // tracking for secondary button
                    if (jSelf.hasClass('secondary')) {
                        if (ipssItemCategory === 'lastSearches') {
                            eventName = '';
                        } else if (ipssItemCategory === 'offer') {
                            actionName = 'offerDetails';
                            eventName = 'details';
                        } else if (ipssItemCategory === 'incompleteContract') {
                            actionName = 'offerDetails';
                            eventName = 'details';
                        }
                    }
                }

                if (ipssItemCategory === 'contract') {
                    actionName = 'details';
                }

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta:' + actionName,
                    ipssItemCategory + ':' + eventName,
                ]);
            });

            $('.box24VsIpss.ipssNewCompareContainer', this.domContext).on('click', '.c24Button', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta:ipss',
                    'cta:newcompare',
                ]);
            });

            if (self.bIsMobile) {
                $('.box24VsIpss', this.domContext).on('c24IpssDelete', '.metaData', function() {
                    const jSelf = $(this);
                    const ipssItemCategory = jSelf.closest('.ipssItem').data('category');

                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'cta:delete',
                        'delete:' + ipssItemCategory,
                    ]);
                });

            } else {
                $('.box24VsIpss', this.domContext).on('c24IpssDelete', '.delete', function() {
                    const jSelf = $(this);
                    const ipssItemCategory = jSelf.closest('.ipssItem').data('category');

                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'cta:delete',
                        'delete:' + ipssItemCategory,
                    ]);
                });
            }
        },
    };
})();
